import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeHlp } from 'src/lib/fliko/helpers/time.helper';
import { TimeDur } from 'src/lib/fliko/types/time.type';
import { RangedReportBase, RangedReportDialogData } from '../../classes/ranged-report';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-ranged-report-dialog',
  templateUrl: './ranged-report-dialog.component.html',
  styleUrls: ['./ranged-report-dialog.component.scss']
})
export class RangedReportDialogComponent<T extends RangedReportBase<U>, U> {
  public form = this.fb.group({ from: null, to: null });
  public today = new Date();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: RangedReportDialogData<T, U>,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RangedReportDialogComponent<T, U>>,
    private ls: LocalizationService
  ) {}

  public get fromMaxDate(): Date {
    const to = TimeHlp.timestamp(this.form.value.to) || Number.POSITIVE_INFINITY;
    return new Date(Math.min(this.today.valueOf(), to));
  }

  public clear(field: 'from' | 'to'): void {
    this.form.patchValue({ [field]: null });
  }

  public apply(): void {
    const fVal = this.form.value;
    const range: TimeDur = {
      from: TimeHlp.timestamp(fVal.from) || Number.NEGATIVE_INFINITY,
      to: fVal.to ? TimeHlp.add(fVal.to, 1, 'DAY') : Number.POSITIVE_INFINITY
    };

    const reportFactory = new this.data.factory(this.data.compData, range, this.ls);

    reportFactory.export();
    this.dialogRef.close();
  }
}
